import axios from 'axios'
import router from '@/router.js'
import { i18n } from '@/main.js' 

import Blob from 'blob';
import FileSaver from 'file-saver';

export default({
    state: {
        tests: [],
        test: null,
    
        createTestDialog: false,
        makeTestFinalDialog: false,
        insertIndexesDialog: false,
        editTestDialog: false,

        removing: false,
        makingFinal: false,
        makingDone: false,

        students: 0, // Used when setting indexes to test
        testDate: null, // Used when making a draft test final
        notes: "",
        title: "",
    },

    getters: {
        getTests(state){ return state.tests },
        getTest(state){ return state.test },

        getCreateTestDialog(state){ return state.createTestDialog },
        getMakeTestFinalDialog(state){ return state.makeTestFinalDialog },
        getInsertIndexesDialog(state){ return state.insertIndexesDialog },
        getEditTestDialog(state){ return state.editTestDialog },

        isRemovingTest(state){ return state.removing },
        isMakingTestFinal(state){ return state.makingFinal },
        isMakingTestDone(state){ return state.makingDone },

        getStudents(state){ return state.students },
        getTestDate(state){ return state.testDate },
        getNotes(state){ return state.notes },
        getTestTitle(state){ return state.title },
    },

    mutations: {
        setTests(state, value){ state.tests = value },
        setTest(state, value){ state.test = value },

        setCreateTestDialog(state, value){ state.createTestDialog = value },
        setMakeTestFinalDialog(state, value){ state.makeTestFinalDialog = value },
        setInsertIndexesDialog(state, value){ state.insertIndexesDialog = value },
        setEditTestDialog(state, value){ state.editTestDialog = value },

        setRemovingTest(state, value){ state.removing = value },
        setMakingTestFinal(state, value){ state.makingFinal = value },
        setMakingTestDone(state, value){ state.makingDone = value },

        setStudents(state, value){ state.students = value },
        setTestDate(state, value){ state.testDate = value },
        setNotes(state, value){ state.notes = value },
        setTestTitle(state, value){ state.title = value },

        newTest(state){
            state.test = {
                title: null,
                subjectId: localStorage.getItem('subjectId')
            }
        },

        resetTestValues(state) {
            state.students = state.test.students
            state.testDate = state.test.testDate
            state.notes = state.test.notes
            state.title = state.test.title
        }
    },

    actions: {
        getTests({ commit }){
            commit('setLoading')
            commit('setTests', [])
            return new Promise(() => {
                axios.get('/tests/subject/' + localStorage.getItem('subjectId'))
                .then((response) => {
                    commit('setTests', response.data)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        getTest({ commit }, id){
            commit('setLoading')
            //commit('setTest', null)
            return new Promise((resolve) => {
                axios.get('/tests/' + id)
                .then((response) => {
                    commit('setTest', response.data)
                    resolve()
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        createTest({ state, commit }){
            commit('setLoading')
            return new Promise(() => {
                axios.post('/tests', state.test)
                .then((response) => {
                    commit('setCreateTestDialog', false)
                    commit('setSnackBar', {value: true, text: i18n.t('testCreated'), color: 'green'})
                    commit('setRemovingTest', false)
                    router.push('/tests/' + response.data.id)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        updateTest({ state, commit, dispatch }){
            commit('setLoading')

            var newTest = {...state.test}

            newTest.students = state.students
            newTest.testDate = state.testDate
            newTest.notes = state.notes
            newTest.title = state.title

            return new Promise(() => {
                axios.put('/tests', newTest)
                .then(() => {
                    commit('setInsertIndexesDialog', false)
                    commit('setMakeTestFinalDialog', false)
                    commit('setEditTestDialog', false)
                    commit('setSnackBar', {value: true, text: i18n.t('testUpdated'), color: 'green'})
                    dispatch('getTest', state.test.id)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        randomizeTest({ state, commit, dispatch }){
            commit('setLoading')
            return new Promise(() => {
                axios.put('/tests/' + state.test.id + '/randomize' )
                .then(() => {
                    dispatch('getFormulationsByTest', state.test.id)
                    .then((testQuestions) => {
                        commit('setQuestions', testQuestions.map(formulation => formulation.question))
                    })
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        removeTest({ state, commit, dispatch }){
            commit('setLoading')
            return new Promise(() => {
                axios.delete('/tests/' + state.test.id)
                .then(() => {
                    commit('setSnackBar', {value: true, text: i18n.t('testRemoved'), color: 'green'})
                    router.push('/tests')
                    dispatch('getTopics')
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        generatePDF({ state, commit }, { markedSolutions, modelNumber }){
            commit('setLoading')

            return new Promise(() => {
                axios.get('/tests/' + state.test.id + (markedSolutions ? '/solvedpdf/' : '/pdf/') + modelNumber)
                .then((response) => {
                    var byteCharacters = atob(response.data);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i = 0; i < byteCharacters.length; i++)
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    var byteArray = new Uint8Array(byteNumbers);
                    var blob = new Blob([byteArray], { type: "application/pdf" });

                    FileSaver.saveAs(blob, state.test.title + ".pdf");
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        }
    },
});
